import { client, clientCall } from './client';
import { appConfig } from '../config/app-config';
import { CancelToken } from 'axios';
import { ProductPermissions } from '../constants/constants';
import { User } from '../types/types';

export const getCurrentUser = (): Promise<User> =>
  client('users/current', { method: 'GET' }, appConfig.apiUrls.container);

export const getUserPreferences = (productType: string) =>
  client(
    `users/current/preferences/${productType}`,
    { method: 'GET' },
    appConfig.apiUrls.container
  );

export const getUserPermissions = (
  productType: string
): Promise<ProductPermissions[]> =>
  client(
    `users/current/permissions/${productType}`,
    { method: 'GET' },
    appConfig.apiUrls.container
  );

export const setUserPreferences = (
  productType: string,
  payload: Record<string, any>,
  cancelToken?: CancelToken
) =>
  client(
    `users/current/preferences/${productType}`,
    {
      method: 'PATCH',
      body: [payload],
      cancelToken,
    },
    appConfig.apiUrls.container
  );

export const getUserStores = () =>
  client(
    'users/current/stores?q=permissions[:includes]=RACPAD_DAP',
    { method: 'GET' },
    appConfig.apiUrls.container
  );

export const getTaxSummary = async (Payload: any) => {
  try {
    return await clientCall(
      `/summary`,
      { method: 'POST', payload: Payload },
      appConfig.apiUrls.micro
    );
  } catch (e: any) {
    return null;
  }
};
export const manageTaxdetails = async (Payload: any) => {
  try {
    return await clientCall(
      `/manage`,
      { method: 'POST', payload: Payload },
      appConfig.apiUrls.micro,
      true
    );
  } catch (e: any) {
    return null;
  }
};
